import { put } from "redux-saga/effects";
import {
  AuthService,
  ForgotPasswordRequestResponse,
} from "../../../services/auth";
import { ForgotPasswordRequestActionType } from "../types";
import axios from "axios";
import {
  forgotPasswordFailure,
  forgotPasswordSuccess,
} from "../actionCreators";
import { IErrorType } from "../../types/errors.d";

export function* forgotPasswordSaga({
  payload: { email, redirect_url },
}: ForgotPasswordRequestActionType) {
  try {
    const {
      data: { data },
    }: ForgotPasswordRequestResponse = yield AuthService.forgotPassword({
      email,
      redirect_url,
    });

    yield put(forgotPasswordSuccess({ data }));
  } catch (error) {
    if (axios.isAxiosError(error))
      yield put(
        forgotPasswordFailure({
          errorType: IErrorType.AXIOS,
          data: error.response ? error.response.data : null,
        })
      );
    else
      yield put(
        forgotPasswordFailure({ errorType: IErrorType.NATIVE, data: error })
      );

    return null;
  }
}
